import BasicText from "../../BasicText";
import LButton from "../../LButton";
import ProjectSlide from "../../ProjectSlide";
import Subtitle from "../../Subtitle";
import Title from "../../Title";
import { HOME_FEATURED_COUNT, PORTFOLIO } from "@/data/portfolio";

function OurPortfolio() {
  return (
    <div className="relative z-20 flex flex-col items-start justify-start w-full xl:w-[1200px] gap-[70px] px-4 sm:px-10 md:px-11 lg:px-12 xl:px-0">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-[20px] w-full">
        <div>
          <Subtitle>
            <div className="pb-[12px]">
              // Our portfolio
            </div>
          </Subtitle>
          <Title>
            <div>
              Products we&apos;ve
            </div>
            <div className="flex flex-row">
              helped&nbsp;<div className="text-luminode-blue">bring onchain</div>
            </div>
          </Title>
        </div>
        <BasicText color="faded" className="text-[12px] xl:text-[16px] tracking-tighter max-w-[340px]">
          <div>A few highlights from the products we&apos;ve designed and built for our partners.</div>
        </BasicText>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-[40px] gap-y-[70px] w-full">
        {PORTFOLIO.slice(0, HOME_FEATURED_COUNT).map((project) => (
          <ProjectSlide key={project.link} {...project} />
        ))}
      </div>
      <div className="w-full flex flex-row justify-center">
        <LButton luminodeicon href="/portfolio">
          View Full Portfolio
        </LButton>
      </div>
    </div>
  );
}

export default OurPortfolio;
